import { memo, useCallback, useEffect, useRef, useState, useMemo } from 'react'
import { motion } from 'framer-motion'

import { LargeTitle, Title } from 'components/home/Sidebar/Tabs/Header/Styles'
import { useTranslation } from 'services/Translation'

import { TABS } from './Tools'
import texts from './Texts'

const Header = ({ tab, setTab }) => {
  const { t } = useTranslation(texts)
  const containerRef = useRef(null)
  const summaryTitleRef = useRef(null)
  const diagnosisTitleRef = useRef(null)
  const encountersTitleRef = useRef(null)
  const [containerWidth, setContainerWidth] = useState(0)
  const [summaryTitleWidth, setSummaryTitleWidth] = useState(0)
  const [diagnosisTitleWidth, setDiagnosisTitleWidth] = useState(0)
  const [encountersTitleWidth, setEncountersTitleWidth] = useState(0)

  const handleTabChange = useCallback(
    newTab => () => {
      if (tab !== newTab) setTab(newTab)
    },
    [tab, setTab]
  )
  useEffect(() => {
    if (
      !encountersTitleWidth &&
      encountersTitleRef?.current &&
      encountersTitleRef?.current?.offsetWidth
    ) {
      setTimeout(() => setEncountersTitleWidth(encountersTitleRef?.current?.offsetWidth), 250)
    }
    if (!summaryTitleWidth && summaryTitleRef?.current && summaryTitleRef?.current?.offsetWidth) {
      setTimeout(() => setSummaryTitleWidth(summaryTitleRef?.current?.offsetWidth), 250)
    }
    if (
      !diagnosisTitleWidth &&
      diagnosisTitleRef?.current &&
      diagnosisTitleRef?.current?.offsetWidth
    ) {
      setTimeout(() => setDiagnosisTitleWidth(diagnosisTitleRef?.current?.offsetWidth), 250)
    }
    if (!containerWidth && containerRef?.current && containerRef?.current?.offsetWidth) {
      setTimeout(() => setContainerWidth(containerRef?.current?.offsetWidth), 250)
    }
  }, [diagnosisTitleRef, diagnosisTitleRef, containerRef, encountersTitleWidth])

  const indicatorLeft = useMemo(() => {
    switch (tab) {
      case TABS.DIAGNOSIS:
        return summaryTitleWidth + 48 + 22
      case TABS.ENCOUNTERS:
        return summaryTitleWidth + diagnosisTitleWidth + (48 + 22) * 2
      default:
        return 0
    }
  }, [tab, summaryTitleWidth, encountersTitleWidth, diagnosisTitleWidth, containerWidth])
  const indicatorWidth = useMemo(() => {
    switch (tab) {
      case TABS.DIAGNOSIS:
        return diagnosisTitleWidth + 48
      case TABS.ENCOUNTERS:
        return encountersTitleWidth + 48
      default:
        return summaryTitleWidth + 48
    }
  }, [tab, summaryTitleWidth, encountersTitleWidth, diagnosisTitleWidth])

  return (
    <div style={{ paddingLeft: '7.5rem', paddingRight: '7.5rem', width: '100%' }}>
      <div className="flex items-center justify-start relative h-12 w-full z-3" ref={containerRef}>
        <div className="relative text-base w-auto text-blue-900 transition z-3 cursor-pointer px-6">
          <LargeTitle
            innerRef={summaryTitleRef}
            className="absolute font-csc65"
            selected={tab === TABS.SUMMARY}
            onClick={handleTabChange(TABS.SUMMARY)}
            data-cy="tabSummary"
          >
            {t('summary')}
          </LargeTitle>
          <Title
            className="font-csc35"
            selected={tab === TABS.SUMMARY}
            onClick={handleTabChange(TABS.SUMMARY)}
            data-cy="tabSummary"
          >
            {t('summary')}
          </Title>
        </div>
        <div
          className="relative text-base w-auto cursor-pointer text-blue-900 transition z-3 px-6"
          style={{ marginLeft: '1.375rem' }}
        >
          <LargeTitle
            innerRef={diagnosisTitleRef}
            className="absolute font-csc65"
            selected={tab === TABS.DIAGNOSIS}
            onClick={handleTabChange(TABS.DIAGNOSIS)}
            data-cy="tabDiagnosis"
          >
            {t('diagnosis')}
          </LargeTitle>
          <Title
            className="font-csc35"
            selected={tab === TABS.DIAGNOSIS}
            onClick={handleTabChange(TABS.DIAGNOSIS)}
            data-cy="tabDiagnosis"
          >
            {t('diagnosis')}
          </Title>
        </div>
        <div
          className="relative text-base w-auto cursor-pointer text-blue-900 transition z-3 px-6"
          style={{ marginLeft: '1.375rem' }}
        >
          <LargeTitle
            innerRef={encountersTitleRef}
            className="absolute font-csc65"
            selected={tab === TABS.ENCOUNTERS}
            onClick={handleTabChange(TABS.ENCOUNTERS)}
            data-cy="tabDiagnosis"
          >
            {t('encounters')}
          </LargeTitle>
          <Title
            className="font-csc35"
            selected={tab === TABS.ENCOUNTERS}
            onClick={handleTabChange(TABS.ENCOUNTERS)}
            data-cy="tabDiagnosis"
          >
            {t('encounters')}
          </Title>
        </div>
      </div>
      <div className="h-px relative w-full bg-grey-100 overflow-hidden">
        <motion.div
          transition={{
            left: { ease: 'easeOut' },
            width: { duration: 0.2 },
          }}
          className="rounded-full h-px -t-px absolute bg-blue-900"
          animate={{
            left: indicatorLeft,
            width: indicatorWidth,
          }}
        />
      </div>
    </div>
  )
}

Header.whyDidYouRender = true

export default memo(Header)
